var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26918",
    "data-name": "Group 26918",
    transform: "translate(-13508 8408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7609",
    "data-name": "Rectangle 7609",
    transform: "translate(13508 -8408)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_203",
    "data-name": "Subtraction 203",
    d: "M-811.8,618.65a2.717,2.717,0,0,1-.744-.1,7.073,7.073,0,0,1-2.908-1.69A14.343,14.343,0,0,1-818,613.572a14.376,14.376,0,0,1-1.632-3.812,6.854,6.854,0,0,1-.034-3.33,2.794,2.794,0,0,1,1.9-1.944l.851-.25a2.082,2.082,0,0,1,.593-.086.737.737,0,0,1,.1,0h.047a2.065,2.065,0,0,1,1.724,1.18l.664,1.444a2.007,2.007,0,0,1,.14,1.241,2,2,0,0,1-.618,1.092l-1.095,1-.008.009a.105.105,0,0,0-.019.043l-.005.026v.012a.7.7,0,0,0,.04.284,5.284,5.284,0,0,0,.561,1.221l.005.012a5.085,5.085,0,0,0,.864,1.15l.016.016a.738.738,0,0,0,.242.148l.019,0,1.457-.438a2.255,2.255,0,0,1,.6-.091,2.075,2.075,0,0,1,1.669.844l.934,1.266a2.013,2.013,0,0,1,.381,1.388,2.035,2.035,0,0,1-.639,1.291l-.642.6A2.815,2.815,0,0,1-811.8,618.65Zm-4.475-13.284h-.053a.747.747,0,0,0-.246.038l-.847.249a1.562,1.562,0,0,0-1.069,1.086,5.657,5.657,0,0,0,.051,2.749,12.846,12.846,0,0,0,1.49,3.468,13.025,13.025,0,0,0,2.316,3,5.923,5.923,0,0,0,2.412,1.424,1.7,1.7,0,0,0,.416.053,1.617,1.617,0,0,0,1.1-.423l.642-.6a.8.8,0,0,0,.107-1.067l-.937-1.265a.841.841,0,0,0-.685-.346.88.88,0,0,0-.254.038l-1.5.445a1.139,1.139,0,0,1-.33.045,1.6,1.6,0,0,1-1.018-.43l-.007-.016-.016-.006-.007-.008-.016-.013a6,6,0,0,1-1.1-1.44l-.015-.024a6.179,6.179,0,0,1-.683-1.524,2.372,2.372,0,0,1-.071-.756l0-.037a1.32,1.32,0,0,1,.421-.8l1.09-.995a.8.8,0,0,0,.191-.927l-.656-1.43a.828.828,0,0,0-.706-.483Z",
    transform: "translate(14330.219 -9011.4)",
    fill: "#6d809f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.636874d665f2a85f6f04fb90b738b297.svg";
export { ForwardRef as ReactComponent };